'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

require('simplemde/dist/simplemde.min.css');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSimplemdeEditor = require('react-simplemde-editor');

var _reactSimplemdeEditor2 = _interopRequireDefault(_reactSimplemdeEditor);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (_ref) {
  var name = _ref.name,
      type = _ref.type,
      context = _ref.context;
  var value = context.value,
      path = context.path,
      _onChange = context.onChange;
  var description = type.description,
      label = type.label,
      _type$defaultValue = type.defaultValue,
      defaultValue = _type$defaultValue === undefined ? "" : _type$defaultValue,
      _type$variant = type.variant,
      variant = _type$variant === undefined ? "primary" : _type$variant,
      passProps = (0, _objectWithoutProperties3.default)(type, ['description', 'label', 'defaultValue', 'variant']);
  return _react2.default.createElement(_reactSimplemdeEditor2.default, (0, _extends3.default)({
    className: 'MarkdownEditor variant-' + variant
  }, passProps, {
    onChange: function onChange(value) {
      return _onChange(path, value);
    },
    value: typeof value === 'string' ? value : defaultValue
  }));
};